import logger from 'nandos-dev-logger'

class ViewStateService {

  constructor() {
    this.router = null;
    this.lastNavigationDirection = '';

    /**
     * States
     * A place to store data associated with a route, so that when a route is returned to,
     * (popped back/up to) the view associated with that route can restore it's previous state.
     */
    this.states = {};
    
    /**
     * Initialisation Data
     * Similar to the states hash, but intended to be used to initialise a view with a given state.
     * For Example: View A can pass info to View B, by setting the initialisation data for the route
     * associated with View B.
     * Unlike states, initialisationData values are not auto-deleted after downwards navigation,
     * they are however auto-deleted after they are read.
     */
    this.initialisationData = {}; // 
    this.previousRoute = null
  }

  init(router) {
    router.afterEach((to, from) => {

      this.lastNavigationDirection = this._getNavigationDirection(to, from);
      this.previousRoute = from

      if(to.query.jump && !to.query.redirect)
        logger.error('Nandos Core-UI', 'When "jumping" to a view, a redirect must be supplied')

      /**
       * Clear any state associated with the next route, if we are moving down (deeper) into the
       * hierarchy. Route state should only be restored when traversing back up the hierarchy.
       */
      if(this.lastNavigationDirection == 'down' || this.lastNavigationDirection == 'jump-up') {
        delete this.states[to.path];
      }
    })

  }

  _getNavigationDirection(to, from) {
    if(to.query.jump) {
      return 'jump-up'
    }
    else if(from.query.jump) {
      return 'jump-down'
    }
    else {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      return toDepth < fromDepth ? 'up' : 'down';
    }
  }

  saveState(key, state) {
    this.states[key] = state;
  }

  getState(key) {
    return this.states[key];
  }

  setInitialisationData(key, data) {
    this.initialisationData[key] = data;
  }

  getInitialisationData(key) {
    let data = this.initialisationData[key]
    delete this.initialisationData[key]
    return data
  }
}


export default new ViewStateService();